import React from "react"
import _props from "../../../../componets/_params";
import apiEndPoints from "../../../../componets/json/apiEndPoints.json"
import { Card, Row, Col, Form, Button, Placeholder } from "react-bootstrap";

class ItemQr extends React.Component {
  state = {
    articles: [],
    loading: false
  }

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <this.props._icon ioqrcodesharp className="c-placeholder c-green" />,
      Title: "QR kódy pro náhradní díly",
      SubTitle: "",
    });
    this.getArticles();
  }

  update = async (idx) => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "post",
      data: this.props._encrypt(JSON.stringify({
        docNo: this.state.articles[idx].DocNo,
        matNo: this.state.articles[idx].MatNo,
        oldqr: this.state.articles[idx].OldQR,
        newqr: this.state.articles[idx].NewQR,
        type: "set"
      })),
      endpoint: apiEndPoints.britex.internal.servis21.qrcode,
      param: "",
    });
    this.setState({ loading: false });
    if (_res.status == 200) this.setState({ articles: JSON.parse(this.props._decrypt(_res.data)) });
  }

  change(e, idx) {
    let articles = this.state.articles;
    if (e.target.id == "oldqr") articles[idx] = { ...articles[idx], OldQR: e.target.value, changer: true }
    if (e.target.id == "newqr") articles[idx] = { ...articles[idx], NewQR: e.target.value, changer: true }
    this.setState({ articles: articles })
  }

  getArticles = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "post",
      data: this.props._encrypt(JSON.stringify({
        docNo: this.props.params.id,
        type: "get"
      })),
      endpoint: apiEndPoints.britex.internal.servis21.qrcode,
      param: "",
    });
    this.setState({ loading: false });
    if (_res.status == 200) this.setState({ articles: JSON.parse(this.props._decrypt(_res.data)) });
  }

  render() {
    const {Bs} = this.props;
    return (
      <>
        {this.state.loading && (
          <Bs card bg="white" className="mb-2">
            <Bs cardbody>
              <Bs row>
                <Bs col xs={8}>
                  <Bs row>
                    <Bs placeholder animation="glow">
                      <Bs placeholder xs={8} />
                    </Bs>
                  </Bs>
                  <Bs row>
                    <Bs placeholder animation="glow">
                      <Bs placeholder xs={8} />
                    </Bs>
                  </Bs>
                </Bs>
                <Bs col xs={2}>
                  <Bs row>
                    <Bs placeholder animation="glow">
                      <Bs placeholder xs={8} />
                    </Bs>
                  </Bs>
                  <Bs row>
                    <Bs placeholder animation="glow">
                      <Bs placeholder xs={8} />
                    </Bs>
                  </Bs>
                </Bs>
                <Bs col xs={2}>
                  <Bs row>
                    <Bs placeholder animation="glow">
                      <Bs placeholder xs={8} />
                    </Bs>
                  </Bs>
                  <Bs row>
                    <Bs placeholder animation="glow">
                      <Bs placeholder xs={8} />
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        )}
        {this.state.articles.map((i, idx) => (
          <>
            <Card bg="white" className="mb-2">
              <Card.Body>
                <Row className="mb-2">
                  <Col xs={12}>
                    <strong>{i.ItemCode}</strong>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={12}>
                    Interní číslo: {i.MatNo}
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    {i.ItemName}
                  </Col>
                  <Col xs={12}>
                    {i.FrgnName}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col xs={12} md={6}>
                    <Form.Control id="oldqr" value={i.OldQR} onChange={(e) => this.change(e, idx)} />
                    <Form.Text>Staré QR</Form.Text>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Control id="newqr" value={i.NewQR} onChange={(e) => this.change(e, idx)} />
                    <Form.Text>Nové QR</Form.Text>
                  </Col>
                </Row>
                {i?.changer && (
                  <Row>
                    <Col className="d-flex justify-content-end">
                      <Button variant="success" size="sm" onClick={() => this.update(idx)}>Aktualizovat</Button>
                    </Col>
                  </Row>
                )}

              </Card.Body>
            </Card>
          </>
        ))}
      </>
    )
  }
}
export default _props(ItemQr);